import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import formField from "MODULES/shared/components/Forms/formField";

export function RadioGroupField({ disabled, input, options = [] }) {
  const activeClass = (type, option) =>
    classNames("btn btn-default", {
      active: input.value === type,
      disabled: disabled || option.disabled
    });

  const handleChange = newVal => () => input.onChange(newVal);

  return (
    <div className="btn-group btn-group-justified" role="group">
      {options.map(option => (
        <div
          className={activeClass(option.value, option)}
          onClick={
            disabled || option.disabled ? undefined : handleChange(option.value)
          }
          key={option.value}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;{option.text}
        </div>
      ))}
    </div>
  );
}

export default formField(RadioGroupField);

RadioGroupField.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  )
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/RadioGroupField/RadioGroupField.jsx